export default __webpack_public_path__ + "static/media/info.29208122.svg";